<app-semantic-link [pConn$]="pConn$"></app-semantic-link>